module.exports = __webpack_public_path__ + "static/Events@0.25x-ded28e31fe45254db162a63aa6156abb.jpg";